// Builds the ContractMain/Update payload sent when the seller links a car to
// the contract and records their asking price, on the merged car-search +
// valuation step (SellerProfileFlow.jsx STEP 2).
//
// Extracted into its own module so the payload shape — in particular that
// `carValuationBySeller` carries the seller's entered price with spaces
// stripped, exactly as the old, separate "valuation" step used to send it —
// can be unit tested without mounting the full flow component.
export function buildCarLinkPayload({ latestContract, newCar, priceValue }) {
  return {
    ...latestContract,
    carInfoId: newCar.id,
    carInfoRegistrationNo: newCar.registrationNo,
    carInfoVehicleDesignation: newCar.vehicleDesignation,
    carInfoTradeName: newCar.tradeName,
    carInfoYearModel: newCar.yearModel,
    carInfoVehicleYears: newCar.vehicleYears,
    carInfoRegistrationDate: newCar.registrationDate,
    carInfoNumberOfUsers: newCar.numberOfUsers,
    carInfoWaxelbarge: newCar.waxelbarge,
    carInfoFourWheelDrive: newCar.fourWheelDrive?.toString() || "False",
    carInfoFuel: newCar.fuel,
    carInfoElectricVehicleConfiguration: newCar.electricVehicleConfiguration,
    carInfoInspectionDate: newCar.inspectionDate,
    carInfoInspectionDateEMPTY: newCar.inspectionDateEMPTY,
    carInfoDispensationInspectionGroup: newCar.dispensationInspectionGroup,
    carInfoInspectionGroup: newCar.inspectionGroup,
    carInfoFeedingStall: newCar.feedingStall,
    carInfoInspectionStation: newCar.inspectionStation,
    carInfoInspectionProgramCode: newCar.inspectionProgramCode,
    carInfoPreviousInspectionDate: newCar.previousInspectionDate,
    carInfoPreviousInspectionProgramCode: newCar.previousInspectionProgramCode,
    carInfoTax: newCar.tax,
    carInfoMalus: newCar.malus,
    carValuationBySeller: priceValue.replace(/\s/g, ""),
    sellerDealComplete: false,
    sellerDrivingLicensePath: "",
  };
}
